import React from 'react';
import './Home.css';
import TestimonialCard from '../components/TestimonialCard';
import Portfolio from './Portfolio'; // Adjust the import path as needed
import Services from './Services'; // Adjust the import path as needed

function Home() {
  const testimonials = [
    { name: 'Amit Sharma', review: 'Ever Bloom transformed my living room into a modern masterpiece. Highly recommended!', rating: 5 },
    { name: 'Priya Singh', review: 'The team at Ever Bloom did an amazing job with our kitchen renovation. It looks stunning!', rating: 4 },
    { name: 'Rahul Verma', review: 'Our outdoor patio looks beautiful thanks to Ever Bloom. Great work!', rating: 5 },
    { name: 'Anjali Mehta', review: 'The luxury bathroom design by Ever Bloom is simply breathtaking. We love it!', rating: 5 },
    { name: 'Vikram Patel', review: 'Ever Bloom provided excellent service and the results were fantastic. Highly recommend!', rating: 4 },
    { name: 'Neha Gupta', review: 'Our office space looks amazing thanks to Ever Bloom. Professional and efficient!', rating: 5 },
    { name: 'Rohit Kumar', review: 'The team at Ever Bloom did a great job with our bedroom design. Very satisfied!', rating: 4 },
    { name: 'Sonal Jain', review: 'Ever Bloom turned our dining room into a beautiful space. Excellent work!', rating: 5 },
  ];

  return (
    <div className="home">
      <section className="hero">
        <div className='hero-overlay'>
          <div className='hero-content'>
            <h1>Welcome to Ever Bloom</h1>
            <p>Crafting elegant spaces for over 14 years.</p>
          </div>
        </div>
      </section>
      <div className="home-portfolio">
        <Portfolio />
      </div>
      <div className="home-services">
        <Services />
      </div>
      <section className="featured-projects">
        <h2>Customer Testimonials</h2>
        <div className="testimonial-gallery">
          {testimonials.map((testimonial, index) => (
            <TestimonialCard key={index} {...testimonial} />
          ))}
        </div>
      </section>
    </div>
  );
}

export default Home;